import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_home_decor_bestsellers: FaireCategoryEntity = {
  token: "cat_home-decor-bestsellers",
  type: "category",
  name: "Bestsellers",
  level: 2,
  parentToken: "cat_home-decor",
  href: "/category/home-decor/bestsellers",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
